import { AxiosInstance, AxiosResponse } from 'axios';
import { useAuthStore } from '@/stores/auth/auth-store';
import { notifyUnauthorized } from './unauthorized-handler';

export const setupInterceptors = (client: AxiosInstance): void => {
  client.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        const url = error.config?.url || '';
        if (!url.includes('/settings/')) {
          useAuthStore.getState().clearAuth();
          notifyUnauthorized();
        }
      }
      return Promise.reject(error);
    }
  );
};
